import { appStore } from '@kaltura-ott/tvpil-shared';

import { ERROR_ACTION_NAMES } from 'consts';

export function checkApiErrorHasRebootError() {
  return !!(
    appStore.apiError &&
    Object.values(appStore.apiError).find((error) => error.actionName === ERROR_ACTION_NAMES.APP_REBOOT)
  );
}
